module.exports = "<div class=\"tile-container clear-float\">\r\n    <a class=\"tile\" uiSref=\"{{item.uiSref}}\" title=\"{{item.title}}\" *ngFor=\"let item of menu\">\r\n        <mat-icon class=\"icon material-icons\">{{item.icon}}</mat-icon>\r\n        <p>{{item.title}}</p>\r\n    </a>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/home/home.component.html
// module id = 1407
// module chunks = 1